
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Construction, Clock } from 'lucide-react';

const CommunityUnderConstruction = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="bg-omoduduwa-indigo text-white py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
            YPL Community
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl">
            Our community platform is being enhanced for a better experience
          </p>
        </div>
      </div>
      
      <div className="container-custom py-16">
        <div className="max-w-2xl mx-auto">
          <Card className="text-center">
            <CardHeader>
              <div className="mx-auto w-20 h-20 bg-omoduduwa-terracotta/10 rounded-full flex items-center justify-center mb-4">
                <Construction className="w-10 h-10 text-omoduduwa-terracotta" />
              </div>
              <CardTitle className="text-2xl text-gray-900 mb-2">
                Community Under Construction
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 mb-6 text-lg">
                We're working hard to rebuild and enhance the YPL Community platform. 
                Our team is implementing new features to make your community experience even better.
              </p>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <Clock className="w-5 h-5 text-omoduduwa-terracotta" />
                  <span className="font-semibold text-gray-900">Coming Soon</span>
                </div>
                <ul className="text-left space-y-2 text-gray-600">
                  <li>• Enhanced member directory and networking</li>
                  <li>• Interactive community forums and discussions</li>
                  <li>• Event management and coordination tools</li>
                  <li>• Resource sharing and collaboration features</li>
                  <li>• Improved mobile experience</li>
                </ul>
              </div>
              
              <p className="text-sm text-gray-500">
                Thank you for your patience as we work to serve you better. 
                Check back soon for updates!
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CommunityUnderConstruction;
